import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "copy",
  "use": "copy-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 16 16\" id=\"copy\"><rect width=\"9.899\" height=\"9.899\" x=\"2.085\" y=\"4.023\" stroke=\"currentColor\" rx=\"2\" /><path stroke=\"currentColor\" stroke-linecap=\"round\" d=\"M5.855 2.079h5.56a2.5 2.5 0 0 1 2.5 2.5v5.5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol